import React from 'react';
import { useMatchPickStats } from '../../../src/worldcup/hooks/useMatchPickStats';
import { MatchPickStatsView } from './MatchPickStatsView';

interface MatchPickStatsScreenProps {
  matchId: string;
  onBack: () => void;
  onEditPick?: () => void;
}

export const MatchPickStatsScreen: React.FC<MatchPickStatsScreenProps> = ({
  matchId,
  onBack,
  onEditPick,
}) => {
  const hookData = useMatchPickStats(matchId);
  return <MatchPickStatsView onBack={onBack} onEditPick={onEditPick} {...hookData} />;
};
